import $ from 'jquery'
import { createApp as createVue, reactive } from 'vue'
// import Vue from 'vue'
import { createPopper } from '@popperjs/core'

// import data from '../data/twitter.json'
// import { Picker, EmojiIndex } from 'emoji-mart-vue-fast'
// let emojiIndex = new EmojiIndex(data, {
//	exclude: ['flags']
// })

import Choices from '../components/choices.vue'
import { makeTimestamp, makeSafeForCss, quoteAttr } from './shared/common-functions.js'
import socket from './socket.js'
import accountFns from './account-functions'

$( function(){
	( function(){
		var connectingDialog = rph.dialogs.Updates
		connectingDialog.show()
		connectingDialog.buttons({
			'Waiting...': function(){}
		})
		connectingDialog.$el.find( '.inner' ).css( 'overflow', 'hidden' )
		var $progressText = $( '<p style="display:inline-block; line-height:25px; text-shadow:0 0.5px 0.5px black;" />' )
			.appendTo( connectingDialog.$el.closest( '.ui-dialog' ).find( '.ui-dialog-buttonset' ) )

		$( '<span>Connecting... </span>' ).appendTo( $progressText )

		if( typeof io === 'undefined' ){
			$progressText.text( 'Error: Could not load resources. CDN is down.' )
			return
		}

		var messengerTimeoutError = setTimeout( function(){
				$progressText.text( 'Failed! Connection timed out. Something is probably wrong with your internet, network, or "security" software on your PC, RPH servers are down, or you simply need to relog.' )
			}, 15000 ),
			passCheck = () => {
				$progressText.html( '<span class="pass">👌 You can now Continue.</span>' )
				connectingDialog.buttons({
					Continue: function(){
						$( this ).dialog( 'close' )
					}
				})
				$progressText.appendTo( connectingDialog.$el.closest( '.ui-dialog' ).find( '.ui-dialog-buttonset' ) )
			}

		socket.once( 'chat-connected', () => {
			socket.emit( 'get-rooms' )
			chatUi.RoomList.show()
		})

		socket.on( 'account-users', () => {
			if( account.userids.length > 0 ){
				clearTimeout( messengerTimeoutError )
				passCheck()
			} else {
				$( '<span class="pass error">Could not fetch characters. You can try clearing cookies, using incognito mode, and/or logging out on the site and in again if this issue persists</span>' ).appendTo( $progressText )
			}
			socket.emit( 'chat-connect', rph.version )
		})
	}() )

	socket.on( 'reconnect', () => {
		// rph.errorDialog.show();
		// rph.errorDialog.$el.find('.msg').html(`<p>A soft reconnect just occured</p>`)
		socket.emit( 'chat-connect', rph.version )
		socket.emit( 'reconnect-room-rejoin', rph.roomsJoined )

		//socket.emit( 'userSubscribe', {userids: Object.keys( messenger.users ).map( userid => parseInt( userid ) )})
		console.log( 'reconnected', 'rejoining', rph.roomsJoined, 'relistening', Object.keys( messenger.users ).map( ( userid ) => parseInt( userid ) ) )
	})

	socket.on( 'disconnect', ( reason ) => {
		console.log( 'disconnect reason:', reason )
		rph.errorDialog.show()
		rph.errorDialog.$el.find( '.msg' ).html( `<p>Connection error.<br />More detail: ${reason}</p><p>You will be reconnected automatically, but sometimes that doesn't work correctly and if you see odd issues you should refresh manually</p>` )
		rph.sounds.wave.play()
		if( reason === 'io server disconnect' ){
			// the disconnection was initiated by the server, you need to reconnect manually
		} else if( reason === 'transport close' ){
			// when server disconnects... usually?
		} else if( reason === 'transport error' ){
			// time out or something
		}
		// else the socket will automatically try to reconnect
	})
	global.logAll = function(){
		/*
			*  This will listen on ALL events and log them
			*/
		var $emit = socket.emit
		socket.emit = function(){ // sending
			var msgs = Array.prototype.slice.call( arguments )
			$emit.apply( socket, arguments )

			var name = msgs[0],
				data = false
			data = msgs[1] ? msgs[1] : false
			var payload = JSON.stringify({name: name, data: data})

			console.log( 'socket.emit', payload )
		}
		var onevent = socket.onevent
		socket.onevent = function(){ // receiving
			var msgs = Array.prototype.slice.call( arguments )[0].data
			// console.log('received', msgs, ' this:', this);
			onevent.apply( socket, arguments )

			var name = msgs[0],
				data = false
			data = msgs[1] ? msgs[1] : false
			var payload = JSON.stringify({name: name, data: data})

			console.log( 'socket.onevent', payload )
		}

		return 'logging all'
	}

	const $chatViewport = $( '#chat-top .inner' )

	/* const $emojiPicker = $(`<div>test picker<picker :data="emojiIndex" :emoji-size="32" set="twitter" title="Select an emoji" emoji="arrow_up"  /></div>`)
		.hide()
		.appendTo('body'); */

	/* createVue({
		data: () => ({
			emojiIndex
		}),
		components: {
			'picker': Picker
		}
	})
	.mount( $emojiPicker[0] ) */

	rph.tabs = {}
	function UserTabBox( User ){
		var thisObj = this,
			userid = User.props.id
		this.User = User
		if( typeof rph.tabs[userid] !== 'undefined' ){
			return rph.tabs[userid]
		}
		this.rooms = []

		this.$el = $( '<ul class="chat-tabs" />' )
			.prependTo( '#chat-tabs' )
		this.$el.prepend( User.$createThumb() )

		this.addTab = function( Room ){
			var thisTab = this,
				$tab = $( '<li class="tab tab-' + makeSafeForCss( Room.props.name ) + ' ' + thisObj.User.props.id + '_' + makeSafeForCss( Room.props.name ) + '">' + Room.props.name + '</li>' )
			$tab.on( 'click', function(){
				Room.makeActive( thisTab.User )
				if( account.settings.sortTabs ){
					thisObj.$el.prependTo( '#chat-tabs' )
				}
			})

			$( '<a class="close ui-corner-all">x</a>' ).on( 'click', function( ev ){
				ev.stopPropagation()
				console.log( 'clicked \'x\'', {userid: thisObj.User.props.id, name: Room.props.name})
				socket.emit( 'leave', {userid: thisObj.User.props.id, name: Room.props.name})
			})
				.appendTo( $tab )
			$( '<span class="notifications"><span class="ping" style="display:none;">!</span><span class="num" style="display:none;">0</span></span>' )
				.appendTo( $tab )

			this.rooms.push( Room )
			this.$el.append( $tab )
			Room.$tabs.push( $tab )

			this.bufferLength = 500
			this.lastTime = Math.round( new Date().getTime() / 1000 )
			this.offenses = 0
			const $textareaWrapper = $( `<div class="${this.User.props.id}_${makeSafeForCss( Room.props.name )}">
					<div class="user-for-textarea">
						<div>
							<span>${this.User.props.name} -&gt ${Room.props.name}</span>
							<!--<div class="controls right-text">&nbsp;<a class="emoji-button">:)</a></div>-->
						</div>
					</div>
				</div>` )
				.appendTo( '#chat-bottom .textarea' )

			$textareaWrapper.find( '.emoji-button' ).on( 'click', function(){
				/* $emojiPicker.show();
				console.log('$emojiPicker.show()', $emojiPicker)
				var emojiPopper = createPopper($textareaWrapper.find('.emoji-button')[0], $emojiPicker[0], {
					placement: 'top',
					modifiers: [
						{
							name: 'preventOverflow',
							options: {
								boundary: window
							}
						},
						{
							name: 'offset',
							options: {
								offset: [0, 25],
							},
						}
					]
				}); */

				$( 'body' ).on( 'mouseup.emojiPicker', function( ev ){
					/* if( $emojiPicker.has(ev.target).length === 0 ){
						$emojiPicker.hide();
						$('body').off('mouseup.emojiPicker')
					} */
				})
			})

			let lastCaretPos = 99
			const getCursorPosition = ( el ) => {
				let pos = 0
				if( 'selectionStart' in el ){
					pos = el.selectionStart
				} else if( 'selection' in document ){
					el.focus()
					const Sel = document.selection.createRange(),
						SelLength = document.selection.createRange().text.length
					Sel.moveStart( 'character', -el.value.length )
					pos = Sel.text.length - SelLength
				}
				lastCaretPos = pos
			}

			$( '<textarea class="' + this.User.props.id + '_' + makeSafeForCss( Room.props.name ) + '" />' )
				.bind( 'keydown', function( ev ){
					if( ev.keyCode === 13 ){
						ev.preventDefault()
						if( ev.ctrlKey === true || ev.shiftKey === true ){
							$( this ).insertAtCaret( '\n' )
						}
					} else if( ev.keyCode === 38 ){
						getCursorPosition( this )
						if( lastCaretPos === 0 ){
							Room.$el.find( '.message-line:has(.slider):gt(-10)' ).last().find( '.slider' ).click()
							$( '#edit' ).click()
						}
					}
				})
				.appendTo( $textareaWrapper )
				.bind( 'keyup', function( ev ){
					if( ev.keyCode === 13 && ev.ctrlKey === false && ev.shiftKey === false && $( this ).val() !== '' && $( this ).val().trim() !== '' ){
						var newMessage = $( this ).val()
						if( newMessage.length > 10000 ){
							Room.appendMessage(
								`<span class="first">&nbsp;</span>
											<span title="${makeTimestamp( false, true )}">Message too long</span>`
							).addClass( 'sys' )
							return
						}
						Room.sendMessage( $( this ).val(), User.props.id )
						$( this ).val( '' )
						var newLength = newMessage.length

						if( newMessage.match( /\n/gi ) ){
							newLength = newLength + ( newMessage.match( /\n/gi ).length * 250 )
						}

						var curTime = Math.round( new Date().getTime() / 1000 )
						thisTab.bufferLength = ( thisTab.bufferLength / ( curTime - thisTab.lastTime + 1 ) ) + ( ( newLength + thisTab.bufferLength ) / 3 ) + 250
						thisTab.lastTime = curTime

						if( thisTab.bufferLength > 1750 ){
							thisTab.offenses += 1
							if( thisTab.offenses > 2 ){
								Room.sendMessage( 'Flood kick', User.props.id )
								$( `<div class="inner dark-bg">
											<p>You have been kicked</p>
											'<p>Reason: Flooding</p>
										</div>` ).dialog().dialog( 'open' )
								socket.disconnect()
							} else {
								Room.appendMessage(
									`<span class="first">&nbsp;</span>
												<span title="'${makeTimestamp( false, true )}">You are flooding. Be careful or you\'ll be kicked</span>`
								).addClass( 'sys' )
								setTimeout( function(){
									thisTab.offenses = 0
								}, 15000 )
							}
						}
					}
				})

			Room.ownUsers.push( User )

			return $tab
		}
		this.removeTab = function( Room ){
			var thisObj = this
			$( '.' + thisObj.User.props.id + '_' + makeSafeForCss( Room.props.name ) ).addClass( 'active' )
			var $toRemove = this.$el.find( '.tab-' + makeSafeForCss( Room.props.name ) )
			Room.$tabs.forEach( ( $tab, i ) => {
				if( $tab.hasClass( '.tab-' + makeSafeForCss( Room.props.name ) ) ){
					$tab.remove()
					Room.$tabs.splice( i, 1 )
				}
			})
			$toRemove.remove()
			$( '#chat-bottom' ).find( '.' + this.User.props.id + '_' + makeSafeForCss( Room.props.name ) ).remove()

			if( !this.$el.find( '.tab' )[0] ){
				this.$el.remove()
				delete rph.tabs[User.props.id]
			}
			$( '#chat-tabs .tab:eq(0)' ).click()

			let index
			rph.roomsJoined.forEach( ( joined, i ) => {
				if( joined.roomname === Room.props.name && joined.user === thisObj.User.props.id ){ index = i }
			})
			if( typeof index !== 'undefined' ){
				rph.roomsJoined.splice( index, 1 )
			}
			if( this.rooms.indexOf( Room ) !== -1 ){
				this.rooms.splice( this.rooms.indexOf( Room ), 1 )
			}
			if( !isInRoom( Room ) ){
				Room.$el.detach()
			}

			Room.ownUsers.splice( Room.ownUsers.indexOf( User ), 1 )
		}

		rph.tabs[userid] = this
	}

	rph.roomsJoined = []
	global.isOwnerOf = function( Room, User ){
		const checkAgainst = typeof User !== 'undefined' ? [User.props.id] : account.userids
		return Room.props.owners.filter( ( userid ) => checkAgainst.includes( userid ) ).length !== 0
	}
	global.isModOf = function( Room, User ){
		const checkAgainst = typeof User !== 'undefined' ? [User.props.id] : account.userids
		return Room.props.mods.filter( ( userid ) => checkAgainst.includes( userid ) ).length !== 0
	}
	global.isInGroup = function( Room, User ){
		const checkAgainst = typeof User !== 'undefined' ? [User.props.id] : account.userids
		return Room.props.members.filter( ( userid ) => checkAgainst.includes( userid ) ).length !== 0
	}
	global.isInRoom = function( Room, User ){
		if( !User ){
			// return rph.roomsJoined.map(room => room.roomname).includes(Room.props.name)
			return rph.roomsJoined.filter( ( pair ) => Room.props.name === pair.roomname ).length !== 0
		} else {
			return rph.roomsJoined.filter( ( pair ) => pair.user === User.props.id ).includes( Room )
		}
	}
	rph.rooms = {}
	const roomnames = []
	function Room( props ){
		if( rph.rooms[props.name] ){
			return rph.rooms[props.name]
		}
		const thisRoom = this

		this.props = reactive( props ),
		this.users = reactive( [] ),
		this.ownUsers = [],
		this.$el = $( `<div class="msgs" data-roomname="${this.props.name}" />` ),
		this.$anchor = $( '<div class="anchor" />' ).appendTo( this.$el ),
		this.$tab = $( '<li class="tab" />' ).text( this.props.name ),
		this.$tabs = [],
		this.active = false

		this.vueEl = $( '<div><choices :start="0" :account="account" /></div>' )
			.prependTo( this.$el )
		this.vue = createVue({
			data: () => ({
				account: account
			}),
			components: {
				choices: Choices
			}
		})
			.mount( this.vueEl[0] )

		roomnames.push( this.props.name )
		rph.rooms[this.props.name] = reactive( this )
		chatUi.RoomList.addRoom( props )

		socket.on( 'update-user', function( data ){
			if( thisRoom.containsUser( data.id ) && thisRoom.props.showLfrp && data.lfrpAd && data.lfrpAd !== '' ){
				getUserById( data.id, function( user ){
					thisRoom.appendMessage(
						`<span class="first">&nbsp;</span>
							<span>` + user.props.vanity || user.props.name + ' has posted an LfRP Ad: ' + user.props.lfrpAd + '</span>'
					).addClass( 'lfrp' )
				})
			}
		})

		bindSliderMenu( this.$el, this.props.name )

		this.containsUser = function( userid ){
			if( thisRoom.users.indexOf( userid ) !== -1 ){
				return true
			} else {
				return false
			}
		}
		this.isActive = function(){
			var $listEl = chatUi.RoomList.$el.find( '.room-header-' + makeSafeForCss( thisRoom.props.name ) )
			return $listEl.hasClass( 'active' )
		}
		this.unmake = function(){
			chatUi.RoomList.removeRoom( thisRoom.props.name )

			const foundi = roomnames.indexOf( this.props.name )
			roomnames.splice( foundi, foundi !== -1 )

			socket.off( 'update-user' )
			delete rph.rooms[thisRoom.props.name]
		}
		this.updateProps = function( props ){
			for( const [key, value] of Object.entries( props ) ){
				thisRoom.props[key] = value
			}
			chatUi.RoomList.updateProps( this.props.name, props )
		}
		this.userJoin = function( userid ){
			if( thisRoom.users.indexOf( userid ) === -1 ){
				thisRoom.users.push( userid )

				let $msgEl = false

				if( isInRoom( thisRoom ) ){ // only show join message if in room
					if( thisRoom.$el.find( '.message-line:last' ).hasClass( 'join' ) ){
						const $last = thisRoom.$el.find( '.message-line:last' ),
							$msgPart = $last.find( 'span:not(.first)' ),
							joinedUsers = $last.data( 'users' )

						joinedUsers.push( userid )

						var html = ''
						joinedUsers.forEach( function( userid, i ){
							html += '<a class="name">' + userid + '</a>'
							if( i === joinedUsers.length - 2 ){
								html += ' and '
							} else if( i !== joinedUsers.length - 1 ){
								html += ', '
							} else {
								html += ' '
							}
						})
						$msgPart.html(
							html + 'have joined ' + thisRoom.props.name
						)
						$msgEl = thisRoom.$el.find( 'div.join:last' )
					} else {
						$msgEl = thisRoom.appendMessage(
							`<span class="first">
									<svg width="0.6em" height="0.6em" viewBox="0 0 100 100">
										<circle fill="#44aa33" r="50" cx="50" cy="50" />
									</svg>
								</span>
								<span><a class="name">` + userid + '</a> has joined ' + thisRoom.props.name + '</span>'
						).data( 'users', [userid] ).addClass( 'join' )
					}
				}

				if( $msgEl ){
					$msgEl.find( '.name' ).each( function( i ){
						const $this = $( this )
						let userid = $( this ).text()

						if( userid == parseInt( userid ) ){
							userid = parseInt( userid )
							getUserById( userid )
								.then( ( User ) => {
									if( User.props ){
										$this.text( User.props.vanity || User.props.name )
											.attr( 'data-content', ( User.props.vanity || User.props.name ) )
											.attr( 'data-name', User.props.name )
											.addClass( 'user-' + User.props.id )
									}
								})
								.catch( ( err ) => {
									console.log( 'userJoin errr', userid, err )
								})
						}
					})
				}
			}
		}
		this.userLeave = function( userid ){
			if( this.users.includes( userid ) ){
				getUserById( userid, function( User ){
					if( isInRoom( thisRoom ) ){
						if( thisRoom.$el.find( '.message-line:last' ).hasClass( 'leave' ) ){
							var $last = thisRoom.$el.find( '.message-line:last' ),
								$msgPart = $last.find( 'span:not(.first)' ),
								joinedUsers = $last.data( 'users' )
							joinedUsers.push( User )
							var html = ''
							joinedUsers.forEach( function( User, i ){
								html += '<a class="name user-' + User.props.id + '" title="' + User.props.name + '" data-name="' + User.props.name + '" data-content="' + ( User.props.vanity || User.props.name ) + '">' + ( User.props.vanity || User.props.name ) + '</a>'
								if( i === joinedUsers.length - 2 ){
									html += ' and '
								} else if( i !== joinedUsers.length - 1 ){
									html += ', '
								} else {
									html += ' '
								}
							})
							$msgPart.html(
								html + 'have left ' + thisRoom.props.name
							)
						} else {
							thisRoom.appendMessage(
								`<span class="first">
										<svg width="0.6em" height="0.6em" viewBox="0 0 100 100">
											<circle fill="#cc4422" r="50" cx="50" cy="50" />
										</svg>
									</span>
									<span><a class="name user-${User.props.id}" title="` + User.props.name + `" data-name="${User.props.name}" data-content="` + ( User.props.vanity || User.props.name ) + '">' + ( User.props.vanity || User.props.name ) + '</a> has left ' + thisRoom.props.name + '</span>'
							).data( 'users', [User] ).addClass( 'leave' )
						}
					}
					if( account.userids.includes( userid ) ){
						new UserTabBox( User ).removeTab( thisRoom )
					}
				})
				this.users.splice( this.users.indexOf( userid ), 1 )
			}
		}
		this.kickMsg = function( targetid, userid, msg ){
			getUserById( userid, function( byUser ){
				getUserById( targetid, function( targetUser ){
					if( account.userids.indexOf( targetUser.props.id ) !== -1 ){
						$( '<div class="inner dark-bg">\n\
							<p>You have been kicked from ' + thisRoom.props.name + ' by ' + byUser.props.name + '</p>\n\ ' +
							( msg !== '' ? '<p>Reason: ' + msg + '</p>\n\ ' : '' ) +
						'</div>' ).dialog().dialog( 'open' )
					}
					thisRoom.appendMessage(
						'<span class="first">&nbsp;</span>\n\
									<span title="' + makeTimestamp( false, true ) + '">' + byUser.props.name + ' has kicked ' + targetUser.props.name +
									( msg !== '' ? ', Reason:' + msg : '' ) +
									'</span>'
					).addClass( 'sys' )
				})
			})
		}
		this.banMsg = function( targetid, userid, msg ){
			getUserById( userid, function( byUser ){
				getUserById( targetid, function( targetUser ){
					if( account.userids.indexOf( targetUser.props.id ) !== -1 ){
						$( '<div class="inner dark-bg">\n\
							<p>You have been banned from ' + thisRoom.props.name + ' by ' + byUser.props.name + '</p>\n\ ' +
							( msg !== '' ? '<p>Reason: ' + msg + '</p>\n\ ' : '' ) +
						'</div>' ).dialog().dialog( 'open' )
					}
					thisRoom.appendMessage(
						'<span class="first">&nbsp;</span>\n\
									<span title="' + makeTimestamp( false, true ) + '">' + byUser.props.name + ' has banned ' + targetUser.props.name +
									( msg !== '' ? ', Reason:' + msg : '' ) +
									'</span>'
					).addClass( 'sys' )
				})
			})
		}
		this.unbanMsg = function( targetid, userid, msg ){
			getUserById( userid, function( byUser ){
				getUserById( targetid, function( targetUser ){
					thisRoom.appendMessage(
						'<span class="first">&nbsp;</span>\n\
									<span title="' + makeTimestamp( false, true ) + '">' + byUser.props.name + ' has unbanned ' + targetUser.props.name + ', Reason:' + msg + '</span>'
					).addClass( 'sys' )
				})
			})
		}
		this.sysMsg = function( msg ){
			thisRoom.appendMessage(
				'<span class="first">&nbsp;</span>\n\
							<span title="' + makeTimestamp( false, true ) + '">' + msg + '</span>'
			).addClass( 'sys' )
		}
		this.enter = function( User ){
			// ui for user joining room..
			rph.roomsJoined.push({roomname: this.props.name, user: User.props.id})
			this.makeActive( User )
			this.$el.prependTo( $chatViewport )

			this.appendMessage(
				`<span class="first">
								<svg width="0.6em" height="0.6em" viewBox="0 0 100 100">
									<circle fill="#44aa33" r="50" cx="50" cy="50" />
								</svg>
							</span>
							<span>You have joined ` + this.props.name + ' on ' + ( User.props.vanity || User.props.name ) + '</span>'
				, true ).addClass( 'join' ) // forceScroll true
			this.appendMessage(
				`<span class="first">&nbsp;</span>
							<div><p>Topic:</p><div>` + parseMsg( this.props.topic ) + '</div></div>'
			).addClass( 'sys' )

			var $tab = new UserTabBox( User ).addTab( this )
			$tab.click()
		}
		this.makeActive = function( User ){
			$chatViewport.find( '.msgs' ).hide()

			var $listEl = chatUi.RoomList.$el.find( '.room-header-' + makeSafeForCss( thisRoom.props.name ) )
			// $('#userlist .rooms').animate({
			//	scrollTop: $('#userlist .rooms').scrollTop() + ( $listEl.position().top - 55 )
			// }, {queue:false});
			chatUi.RoomList.$el.find( '.room' ).removeClass( 'active' )
			$listEl.addClass( 'active' )
			$( '#top' ).html( '<span>' + thisRoom.props.name + ' | ' + parseMsg( thisRoom.props.topic ) + '</span>' ).attr( 'title', thisRoom.props.topic )

			$( '#chat-bottom .tab, #chat-bottom textarea, #chat-bottom .textarea > div' ).removeClass( 'active' )
			$( '.' + User.props.id + '_' + makeSafeForCss( thisRoom.props.name ) ).addClass( 'active' )

			this.$el.show()

			this.$tabs.forEach( function( $tab ){
				$tab.find( '.notifications .ping' ).hide()
				$tab.find( '.notifications .num' ).hide().text( 0 )
			})

			for( const [key, tab] of Object.entries( rph.tabs ) ){
				tab.rooms.forEach( function( Room ){
					Room.active = false
				})
			}

			this.$anchor[0].scrollIntoView({ block: 'nearest', inline: 'start' })

			this.active = true
		}
		this.leave = function( User ){
			// hm... is this even nessisary?
		}
		this.sendMessage = function( msg, userid ){
			socket.emit( 'force-idle-end', userid )
			var data = {msg: msg, room: this.props.name, userid: userid}
			socket.emit( 'msg', data )
		}
		this.appendMessage = function( html, forceScroll ){
			var $el = $( `<div class="message-line">
							${html}
						</div>` )
				.insertBefore( this.$el.find( '.anchor' ) )

			// console.log('anchor isInViewport', this.$anchor.isInViewport(this.$el), this.$anchor, 'prev msg isInViewport', $el.prev().isInViewport(this.$el), $el.prev())
			if( !this.$anchor.isInViewport( $chatViewport ) && $el.prev().isInViewport( $chatViewport ) ){
				// console.log('!!!!! force scroll', $el)
				this.$anchor[0].scrollIntoView({ block: 'nearest', inline: 'start' })
			}
			if( forceScroll ){
				this.$anchor[0].scrollIntoView({ block: 'nearest', inline: 'start' })
				setTimeout( () => {
					this.$anchor[0].scrollIntoView({ block: 'nearest', inline: 'start' })
				}, 150 )
			}

			if( this.$el.children( 'div' ).length > account.settings.maxHistory ){
				this.$el.children( 'div:not(.sys):lt(3)' ).remove()
			}
			$el.find( '.img-wrapper' ).each( function(){
				var $this = $( this ),
					url = $this.attr( 'href' )
				if( url.slice( url.length - 3 ) !== 'gif' ){
					var $checker = $( '<img src="' + url + '"/>' ).hide().appendTo( 'body' )
					$checker.load( function(){
						if( $checker.height() <= 90 && $checker.width() <= 120 ){
							$this.replaceWith( '<img src="' + url + '" class="smily" />' )
						} else {
							$( '<span class="redirect-icon">&#9112;</span>' ).prependTo( $this )
							$this.find( '.redirect-icon' ).click( function( ev ){
								ev.preventDefault()
								ev.stopPropagation()
								var matched = html.match( /([http|https]+:\/\/\S*\.(jpg|jpeg|png|gif))/i )[0]
								$( '<div class="innerbg smallBorders" style="padding:0 2px;height:100%;"><img src="' + matched + '" /></div>' ).dialog({
									bgiframe: true,
									title: 'Image',
									width: $checker.width() + 5,
									height: $checker.height() + 38,
									position: { my: 'top', at: 'top', of: window }
								}).dialog( 'open' )
							})
						}
					})
				}
			})

			return $el
		}
		this.locked = {}
		this.locked.onMessage = function( data ){
			if( account.ignores.indexOf( data.userid ) !== -1 ){
				return
			}
			var timestamp = makeTimestamp( data.time ),
				timestampWSeconds = makeTimestamp( data.time, true ),
				msg = parseMsg( data.msg )

			// ping on name match
			if( thisRoom.ownUsers.length !== 0 ){
				const matchNames = []
				thisRoom.ownUsers.forEach( ( user ) => {
					matchNames.push( user.props.name )
					if( user.props.vanity ){
						matchNames.push( user.props.vanity )
					}
				})
				const escapedNames = matchNames.map( ( username ) => {
						return username.replace( /([.?*+^$[\]\\(){}|-])/g, '\\$&' )
					}),
					notifyWords = account.settings.notifyWords.split( ',' ).map( ( item ) => {
						return item.trim().replace( /([.?*+^$[\]\\(){}|-])/g, '\\$&' )
					}),
					nameKeys = new RegExp( '\\b' + escapedNames.join( '\\b|\\b' ) + '\\b', 'g' )
				let notifyKeys = new RegExp( '\\b' + notifyWords.join( '\\b|\\b' ) + '\\b', ( account.settings.notifyWordsi ? 'g' : 'gi' ) )

				if( notifyWords[0] === '' ){
					notifyKeys = /.^/ // match nothing
				}
				if( msg.search( nameKeys ) !== -1 || msg.search( notifyKeys ) !== -1 ){
					var notifyOnRegexp = function( regexp, msg ){
						if( !thisRoom.active ){
							thisRoom.$tabs.forEach( function( $tab ){
								$tab.find( '.notifications .ping' ).show()
								$tab.one( 'click', function(){
									rph.pinged = false
									drawIcon()
								})
							})
							rph.pinged = true
							drawIcon()
						}
						return msg = msg.replace( regexp, function( match, offset, full ){
							var mIndex = matchNames.indexOf( match ) + 1
							if( matchNames.length > 1 ){
								match = match + '(tab ' + mIndex + ')'
							}
							return '<span class="highlight">' + match + '</span>'
						})
					}
					msg = notifyOnRegexp( nameKeys, msg )
					msg = notifyOnRegexp( notifyKeys, msg )

					rph.sounds.notify.play()
				}
			}
			if( !thisRoom.active ){
				thisRoom.$tabs.forEach( function( $tab ){
					var curUnread = parseInt( $tab.find( '.notifications .num' ).text() )
					$tab.find( '.notifications .num' ).text( curUnread + 1 ).show()
				})
			}
			// end ping

			var classes = '',
				$el = '',
				$prevEl = thisRoom.$el.find( '>.message-line:last' )

			const html = '<span class="first"><span class="timestamp" data-unixtime="' + data.time + '" data-userid="' + data.userid + '">' + timestamp + '</span>'
			if( data.msg.charAt( 0 ) === '/' && data.msg.toLowerCase().slice( 1, 3 ) === 'me' ){
				classes += 'action '
				$el = thisRoom.appendMessage(
					html + `</span>
								<p class="content">
									<a class="name" title="` + timestampWSeconds + '">' + data.userid + `</a>
									<span class="message" data-unparsed="` + quoteAttr( data.msg ) + '">' + msg + `</span>
								</p>
								<div class="message-right" />`
				).addClass( classes )

				if( accountFns.isOwnUser( account, data.userid ) ){
					$el.find( '.message-right' ).append( '<a class="slider">⋮</a>' )
				}
			} else if( $prevEl.find( '.name' ).data( 'userid' ) === data.userid ){
				var $textHtml = $prevEl.find( '.message' )
				if( $textHtml[0] ){
					$textHtml.html( $textHtml.html() + '<br />' + msg )
					$textHtml.attr( 'data-unparsed', $textHtml.attr( 'data-unparsed' ) + '\n' + quoteAttr( data.msg ) )
				}
				$el = $prevEl
			} else {
				$el = thisRoom.appendMessage(
					html + `<a class="name" title="${timestampWSeconds}">${data.userid}</a></span>
							<p class="content">
								<span class="message" data-unparsed="${quoteAttr( data.msg )}">${msg}</span>
							</p>
							<div class="message-right" />`
				).addClass( classes )
				$el.find( '.name' ).data( 'userid', data.userid )

				if( accountFns.isOwnUser( account, data.userid ) ){
					$el.find( '.message-right' ).append( '<a class="slider">⋮</a>' )
				}
			}
			if( $prevEl.find( '.timestamp' ).text() === timestamp ){
				$el.find( '.timestamp' ).hide()
			}
			if( data.newMsg ){
				editMessage( $el.find( '.message' ), data.newMsg, data.editDate )
			}
			if( data.roll ){
				appendRollResult( $el.find( '.message' ), data.roll, data.animate )
			}
			$el.find( 'br:gt(10)' ).remove()

			$el.find( '.has-image' ).each( function(){
				var $this = $( this ),
					img = new Image()
				img.src = $( this ).attr( 'href' )
				$( img ).on( 'load', function(){
					if( img.width <= 70 && img.height <= 50 ){
						$this.replaceWith( img )
					}
				})
			})

			getUserById( data.userid, function( User ){
				if( User.friendOf ){
					classes += 'friend '
				}
				if( accountFns.isOwnUser( account, User ) ){
					classes += 'self '
				}
				if( isOwnerOf( thisRoom, User ) ){
					classes += 'owner '
				} else if( isModOf( thisRoom, User ) ){
					classes += 'mod '
				}
				if( isInGroup( thisRoom, User ) ){
					classes += 'group-member '
				}
				$el.addClass( classes )
				$el.find( '.name' ).text( User.props.vanity || User.props.name )
					.attr( 'data-content', ( User.props.vanity || User.props.name ) )
					.attr( 'data-name', User.props.name )
					.addClass( 'user-' + User.props.id )
				if( $el.find( '.name' ).length > 0 ){
					if( Array.isArray( User.props.color ) ){
						User.props.color.forEach( ( hex, i ) => {
							$el.find( '.name' ).get( 0 ).style.setProperty( '--color' + ( i + 1 ), '#' + User.props.color[i] )
						})
						if( $el.find( '.message' )[0] ){
							$el.find( '.message' ).get( 0 ).style.setProperty( '--color1', '#' + User.props.color[0] )
						}
					}
				}
				if( User.props.fade ){
					if( User.props.fade === 1 ){
						$el.find( '.name' ).addClass( 'vertical-fade' )
					} else if( User.props.fade === 2 ){
						$el.find( '.name' ).addClass( 'horizontal-fade' )
					} else if( User.props.fade === 3 ){
						$el.find( '.name' ).addClass( 'radial-fade' )
					}
				}
				if( User.props.color.length > 1 ){
					let numColorClass = '-color'
					if( User.props.color.length == 2 ){
						numColorClass = 'two' + numColorClass
					} else {
						numColorClass = 'three' + numColorClass
					}
					$el.find( '.name' ).addClass( numColorClass )
				}
			})
		}
		Object.freeze( this.locked )
	}

	global.getRoom = ( name ) => {
		return rph.rooms[name] || false
	}

	socket.on( 'room-new', function( rooms ){
		rooms.forEach( ( props ) => {
			if( !getRoom( props.name ) ){
				// console.log('room-new', props)
				new Room( props )
			}
		})
	})
	socket.on( 'room-delete', function( name ){
		// console.log('room-delete', name, getRoom(name));
		const Room = getRoom( name )
		if( Room ){
			Room.unmake()
		}
	})

	socket.on( 'room-change', function( data ){
		const Room = getRoom( data.name )
		if( Room ){
			Room.updateProps( data.props )
		}
	})

	socket.on( 'room-users', function( data ){
		// console.log( 'room-users', data ) // not firing after rejoining room or something...
		const Room = getRoom( data.room )
		data.users.forEach( ( userid ) => {
			Room.userJoin( userid )
		})
	})
	socket.on( 'room-users-leave', ( data ) => {
		const Room = getRoom( data.room )
		if( Room ){
			data.users.forEach( ( userid ) => {
				Room.userLeave( userid )
			})
		}
	})
	socket.on( 'user-kicked', function( data ){
		getRoom( data.room ).kickMsg( data.targetid, data.userid, data.msg )
	})
	socket.on( 'user-banned', function( data ){
		getRoom( data.room ).banMsg( data.targetid, data.userid, data.msg )
	})
	socket.on( 'user-unbanned', function( data ){
		getRoom( data.room ).unbanMsg( data.targetid, data.userid, data.msg )
	})
	socket.on( 'msg-sys', function( data ){
		const Room = getRoom( data.room )
		Room && Room.sysMsg( data.msg )
	})

	socket.on( 'confirm-room-join', function( data ){
		const Room = getRoom( data.room )
		chatUi.RoomList.showRoom( data.room )
		chatUi.RoomList.hide()
		getUserById( data.userid, function( User ){
			if( !isInRoom( Room, User ) ){ // might be rejoining on reconnect and already have UI made
				Room.enter( User )
			}
		})
		$( '#chat-top' ).css({paddingBottom: '119px'})
		$( '#chat-bottom' ).css({marginTop: '-119px'})
		console.log( 'confirm-room-join', data )
	})
	socket.on( 'room-join-error', function( data ){
		var error = data.error
	})

	socket.on( 'confirm-unlisten', function( roomname ){
		// console.log('confirm-unlisten');
		// chatUi.RoomList.$el.find('.room-header-'+makeSafeForCss(roomname)+' .users .user').each(function(){
		//	$(this).data('User').$removeEl( $(this) );
		// });
	})

	socket.on( 'msg', function( data ){
		data.forEach( ( msg ) => {
			getRoom( msg.room ).locked.onMessage( msg )
		})
	})

	socket.on( 'random-quote', function( data ){
		$( '#random-quote' ).text( data )
	})

	socket.on( 'room-join-error', function( data ){
		let msg = data.msg
		switch ( data.msgid ){
			case 500:
				msg = 'Banned'
				break
			case 200:
				msg = 'Already in room'
				break
			case 201:
				msg = 'This room has a limit of users, and is full'
				break
			case 202:
				msg = 'This room has a limit of characters per account, and yours exceeds it'
				break
			case 203:
				msg = 'Wrong password'
				break
			case 204:
				msg = 'This room only allows members of its group to join, and you\'re not in its group'
				break
		}
		rph.errorDialog.show()
		rph.errorDialog.$el.find( '.msg' ).html( '<p>Error trying to join ' + data.room + '.<br />' + data.msgid + ':' + msg + '</p>' )
	})
})
